module.exports = __webpack_public_path__ + "files/6e713d143fed2ef43eb9e13b7befc538.svg";